<template>
  <div>
    <v-container
      fluid
      class="fill-height"
    >
      <v-row>
        <v-col class="pt-0">
          <v-progress-linear
            indeterminate
            height="2"
            v-if="fetching"
          ></v-progress-linear>
          <template v-else-if="order">
            <v-row>
              <v-col
                cols="12"
                md="8"
                lg="9"
              >
                <general-details :order="order" />
                <tasks :order="order._id" />
                <notes
                  :parentId="order._id"
                  :parentType="'order'"
                  :add="createNote"
                />
                <items :order="order" :add="createOrderItem" />
                <customers :order="order" />
                <payments :order="order" :add="makePayment" :addManual="createPayment" />
              </v-col>
              <v-col
                cols="12"
                md="4"
                lg="3"
              >
                <v-card flat>
                  <v-toolbar
                    dense
                    flat
                  >
                    <v-toolbar-title>פעולות</v-toolbar-title>
                  </v-toolbar>
                  <v-divider />
                  <v-list nav>
                    <template v-for="(item) in actionsMenu">
                      <v-list-item
                        :key="item.title"
                        @click="envokeMethodByName(item.action)"
                        v-if="item.viewIf ? propertByName(item.viewIf) : true"
                        class="ma-0"
                      >
                        <v-list-item-avatar>
                          <v-progress-circular
                            indeterminate
                            :size="20"
                            :width="2"
                            color="primary"
                            v-if="propertByName(item.loading) || false"
                          ></v-progress-circular>
                          <v-icon
                            v-else
                            :color="item.color"
                          >{{ item.icon }}</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title><span :class="`${item.color}--text`">{{ item.title }}</span></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <v-alert
            :value="true"
            color="white"
            class="grey--text"
            icon="mdi-information-outline"
            v-else
          >
            נתוני הזמנה לא נמצאו. נסו לטעון את הדף מחדש
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
    <book-out-dialog :orderId="orderId" />
    <check-in-dialog :orderId="orderId" />
    <send-email-dialog :orderId="orderId" />
    <send-sms-dialog :orderId="orderId" />
    <payment-dialog :orderId="orderId" :isFinalizing="isFinlizing" />
  </div>
</template>

<script>
import Notes from "@/components/notes/Notes";
import BookOutDialog from "@/components/orders/BookOutDialog";
import CheckInDialog from "@/components/orders/CheckInDialog";
import SendEmailDialog from "@/components/SendEmailDialog";
import SendSmsDialog from "@/components/SendSmsDialog";
import PaymentDialog from "@/components/PaymentDialog";
import GeneralDetails from "@/components/orders/GeneralDetails";
import Items from "@/components/orders/Items";
import Customers from "@/components/orders/Customers";
import Payments from "@/components/orders/Payments";
import Tasks from "@/components/tasks/Tasks";
import { format } from "date-fns";
import generateId from "@/idGenerator";
import { getApi } from "@/api";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      tab: null,
      fetching: true,
      removing: false,
      settingOfficeCheckbox: false,
      isFinlizing: false,
      actionsMenu: [
        {
          icon: "mdi-checkbox-blank-outline",
          color: "primary",
          title: "מכשיר בסניף",
          action: "toggleOfficeCheckbox",
          loading: "settingOfficeCheckbox",
          viewIf: "isNotOfficeCheckbox"
        },
        {
          icon: "mdi-check-box-outline",
          color: "primary",
          title: "מכשיר בסניף",
          action: "toggleOfficeCheckbox",
          loading: "settingOfficeCheckbox",
          viewIf: "isOfficeCheckbox"
        },
        {
          icon: "mdi-account-arrow-left",
          color: "primary",
          title: "מסירה",
          action: "bookOut",
          viewIf: "isStatusPaid"
        },
        {
          icon: "mdi-account-arrow-right",
          color: "primary",
          title: "החזרה",
          action: "checkIn",
          viewIf: "isStatusBookedOut"
        },
        {
          icon: "mdi-credit-card",
          color: "primary",
          title: "סגירת הזמנה",
          action: "finalize",
          viewIf: "isStatusCheckedIn"
        },
        // {
        //   icon: "mdi-credit-card-plus",
        //   color: "primary",
        //   title: "חיוב/זיכוי אשראי ידני",
        //   action: "makePayment"
        // },
        {
          icon: "mdi-email",
          color: "primary",
          title: "שליחת אי-מייל",
          action: "sendEmail"
        },
        {
          icon: "mdi-cellphone-message",
          color: "primary",
          title: "שליחת SMS",
          action: "sendSms"
        },
        // {
        //   icon: "mdi-comment-plus",
        //   color: "primary",
        //   title: "הוספת הערה",
        //   action: "createNote"
        // },
        {
          icon: "mdi-pencil",
          color: "primary",
          title: "עריכת פרטי מוכר",
          action: "editOrderAgent"
        },
        {
          icon: "mdi-pencil",
          color: "primary",
          title: "עריכת פרטי מסירה",
          action: "editOrderBookOut"
        },
        {
          icon: "mdi-pencil",
          color: "primary",
          title: "עריכת פרטי החזרה",
          action: "editOrderCheckIn"
        },
        {
          icon: "mdi-pencil",
          color: "primary",
          title: "עריכת פרטים כללים",
          action: "edit"
        },
        {
          icon: "mdi-cancel",
          color: "red",
          title: "ביטול הזמנה",
          action: "cancel"
        },
        // {
        //   icon: "mdi-delete",
        //   color: "red",
        //   title: "מחיקה",
        //   action: "remove",
        //   loading: "removing"
        // }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    orderId() {
      return this.$route.params.id;
    },
    order() {
      return this.$store.getters["entity"]("orders", this.orderId);
    },
    orderType() {
      let type = this.order.type;
      if (type) {
        return this.$store.getters["entity"]("orderTypes", type);
      } else {
        return null;
      }
    },
    boxType() {
      let type = this.order.boxType;
      if (type) {
        return this.$store.getters["entity"]("boxTypes", type);
      } else {
        return null;
      }
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    storeTransferDialog: {
      get() {
        return this.$store.state.storeTransferDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_STORE_TRANSFER_DIALOG", isActive);
      }
    },
    status() {
      let status = this.order.status;
      if (status) {
        return this.$store.state.entities.orderStatuses[status];
      } else {
        return null;
      } 
    },
    isOfficeCheckbox() {
      return this.order.officeCheckbox;
    },
    isNotOfficeCheckbox() {
      return !this.isOfficeCheckbox;
    },
    isStatusPaid() {
      return this.status.key === 'PAID';
    },
    isStatusBookedOut() {
      return this.status.key === 'BOOKED_OUT';
    },
    isStatusCheckedIn() {
      return this.status.key === 'CHECKED_IN';
    },
    bookOutDialog: {
      get() {
        return this.$store.state.bookOutDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_BOOK_OUT_DIALOG", isActive);
      }
    },
    checkInDialog: {
      get() {
        return this.$store.state.checkInDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_CHECK_IN_DIALOG", isActive);
      }
    },
    sendEmailDialog: {
      get() {
        return this.$store.state.sendEmailDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_SEND_EMAIL_DIALOG", isActive);
      }
    },
    sendSmsDialog: {
      get() {
        return this.$store.state.sendSmsDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_SEND_SMS_DIALOG", isActive);
      }
    },
    paymentDialog: {
      get() {
        return this.$store.state.paymentDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_PAYMENT_DIALOG", isActive);
      }
    }
  },
  methods: {
    format,
    propertByName(name) {
      return this[name];
    },
    envokeMethodByName(name) {
      this[name]();
    },
    toggleOfficeCheckbox() {
      this.settingOfficeCheckbox = true;
      let params = {
        officeCheckbox: !this.order.officeCheckbox
      };
      getApi()
        .then(api => {
          return api.patch(`/orders/${this.orderId}`, params);
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.settingOfficeCheckbox = false;
        });
    },
    edit() {
      let resource = this.$store.state.resources.order;
      this.editEntity(this.order, resource);
    },
    editOrderAgent() {
      let resource = this.$store.state.resources.orderAgent;
      this.editEntity(this.order, resource);
    },
    editOrderBookOut() {
      let resource = this.$store.state.resources.orderBookOut;
      this.editEntity(this.order, resource);
    },
    editOrderCheckIn() {
      let resource = this.$store.state.resources.orderCheckIn;
      this.editEntity(this.order, resource);
    },
    remove() {
      this.$root.$confirm("האם למחוק את ההזמנה?").then(res => {
        if (!res) {
          return;
        }

        let id = this.order._id;

        this.removing = true;
        this.$store
          .dispatch("REMOVE_ENTITY", {
            url: "/orders",
            entityType: "orders",
            id
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "הפריט נמחק",
              color: "success"
            });
            this.$router.go(-1);
          })
          .catch(err => {
            console.log(err.stack);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.removing = false;
          });
      });
    },
    cancel() {
      this.$root.$confirm("האם לבטל את ההזמנה?").then(res => {
        if (!res) {
          return;
        }

        this.canceling = true;
        getApi()
          .then(api => {
            return api.post(`/orders/${this.orderId}/cancel`);
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "ההזמנה בוטלה בהצלחה",
              color: "success"
            });
          })
          .catch(err => {
            console.log(err.stack);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.canceling = false;
          });
      });
    },
    fetch() {
      this.fetching = true;
      this.$store
        .dispatch("API_GET", {
          url: "/orders/" + this.orderId,
          entityType: "orders",
          schema: "orderListSchema"
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    createNote() {
      let newEntity = {
        _id: generateId(),
        order: this.order._id,
        user: this.user._id
      };
      let resource = this.$store.state.resources.note;
      this.editEntity(newEntity, resource, true);
    },
    createPayment() {
      let newEntity = {
        _id: generateId(),
        order: this.order._id,
        user: this.user._id
      };
      let resource = this.$store.state.resources.payment;
      this.editEntity(newEntity, resource, true);
    },
    createOrderItem() {
      let newEntity = {
        _id: generateId(),
        order: this.order._id
      };
      let resource = this.$store.state.resources.orderItem;
      this.editEntity(newEntity, resource, true);
    },
    bookOut() {
      this.bookOutDialog = true;
    },
    checkIn() {
      this.checkInDialog = true;
    },
    sendEmail() {
      this.sendEmailDialog = true;
    },
    sendSms() {
      this.sendSmsDialog = true;
    },
    finalize() {
      this.isFinlizing = true;
      this.paymentDialog = true;
    },
    makePayment() {
      this.isFinlizing = false;
      this.paymentDialog = true;
    }
  },
  mounted() {
    this.fetch();
  },
  watch: {},
  components: {
    GeneralDetails,
    Items,
    Customers,
    Payments,
    BookOutDialog,
    CheckInDialog,
    SendEmailDialog,
    SendSmsDialog,
    PaymentDialog,
    Tasks,
    Notes
  },
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
